import React, { useEffect } from 'react';
import UserSettings from '@app/containers/components/UserSettings';
import { $client } from '../../store/states';
import { useStore } from 'effector-react';
import { clientApi } from '../../store/apis';
import { usePageTitle } from '@app/hooks';

const ClientSettings: React.FC = () => {
    const { changeTitle } = usePageTitle('Client Settings');

    const client = useStore($client);

    useEffect(() => {
        if (!client) {
            return;
        }

        changeTitle(`Client Settings - ${client.first_name} ${client.last_name}`);
    }, [client?.first_name, client?.last_name]);

    if (!client) {
        return null;
    }

    return (
        <UserSettings
            userId={client.id}
            onChangeEmailSuccess={(email) => clientApi.update({ email })}
            onVerifyUserSuccess={clientApi.verify}
            onRemoveUserVerificationSuccess={clientApi.removeVerification}
        />
    );
};

export default ClientSettings;
